if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // On main product page, deselect size on initial load so customer must choose
        this.sizeRequired = false;
        if (this.closest('[id^="MainProduct"]')) {
          const sizeFieldset = this.closest('product-info')?.querySelector('[data-option-size]');
          if (sizeFieldset) {
            this.sizeRequired = true;
            this.sizeFieldset = sizeFieldset;
            const checkedInput = sizeFieldset.querySelector('input:checked');
            if (checkedInput) {
              checkedInput.checked = false;
            }
            const selectedValueSpan = sizeFieldset.querySelector('[data-selected-value]');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = '';
            }
            sizeFieldset.addEventListener('change', () => {
              this.sizeRequired = false;
              sizeFieldset.classList.remove('size-not-selected');
              this.handleErrorMessage();
            });
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Check if size selection is required but not yet chosen
        if (this.sizeRequired) {
          const sizeFieldset = this.sizeFieldset || this.closest('product-info')?.querySelector('[data-option-size]');
          if (sizeFieldset) {
            const hasSelection = sizeFieldset.querySelector('input:checked');
            if (!hasSelection) {
              sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
              sizeFieldset.classList.add('size-not-selected');
              setTimeout(() => sizeFieldset.classList.remove('size-not-selected'), 2000);
              this.handleErrorMessage('Please select a size');
              return;
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const brushingProduct = document.getElementById('brushing-product');
            if (
              brushingProduct != null &&
              brushingProduct.dataset.price !== '' &&
              brushingProduct.dataset.price !== undefined
            ) {
              this.handleBrushingProduct(brushingProduct, response.title);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleBrushingProduct(brushingProduct, referenceTitle) {
        const presetId = document.querySelector('.presetId').value;

        let quantity = 1;
        if (document.querySelector('.quantity__input') != null) {
          quantity = document.querySelector('.quantity__input').value;
        }

        const additionalProductData = {
          id: brushingProduct.dataset.id,
          quantity: quantity,
          properties: {
            brushingID: presetId,
            Product: referenceTitle,
          },
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(additionalProductData),
        })
          .then((additionalResponse) => additionalResponse.json())
          .then(() => {
            window.location = window.routes.cart_url;
          })
          .catch((error) => {
            console.error('Error adding additional product:', error);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
